export enum DropDownValues {
  HERR = "Herr",
  FRAU = "Frau",
  FIRMA = "Firma",
  JAEHRLICH = "Jährlich",
  HALBJAEHRLICH = "Halbjährlich",
  VIERTELJAEHRLICH = "Vierteljährlich",
  MONATLICH = "Monatlich",
  HAFTPFLICHT = "Haftpflicht",
  TEILKASKO = "Teilkasko",
  VOLLKASKO = "Vollkasko",
  NUM_0 = "0",
  NUM_150 = "150",
  NUM_300 = "300",
  NUM_500 = "500",
  NUM_1000 = "1000",
  NUM_2500 = "2500",
  NUM_5000 = "5000",
  NUM_10000 = "10000",
  //
  EIGENTUM_VN = "Eigentum VN",
  FINANZIERUNG = "Finanzierung",
  LEASING = "Leasing",
  //
  SMART = "Smart",
  KOMFORT = "Komfort",
  PREMIUM = "Premium",
  JA = "Ja",
  NEIN = "Nein",
  EMPTY = "",
  GBR = "GBR",
  OHG = "OHG",
  GMBH = "GmbH",
  GGMBH = "gGmbH",
  GMBH_CO_KG = "GmbH & Co. KG",
  KGAA = "KGaA",
  VEREIN_NACH_BGB = "Verein nach BGB",
  EG = "eG",
  EV = "e.V.",
  PARTG = "PartG",
  PARTNERREEDEREI = "Partnerreederei",
  GMBHUNDCOKGAA = "GmbH und Co. KGaA",
  AGCOKGAA = "AG & Co. KGaA",
  GAG = "gAG",
  KG = "KG",
  LTD = "Ltd",
  AG = "AG",
  KDOER = "KdöR",
  STIFTUNGDESOEFFENTLICHENRECHTS = "Stiftung des öffentlichen Rechts",
  ZWECKVERBAND = "Zweckverband",
  GEWERKSCHAFT = "Gewerkschaft",
  SONSTIGE = "Sonstige",
  SF_M = "M",
  SF_0 = "0",
  SF_S = "S",
  SF_1_2 = "SF1/2",
  SF_1 = "SF1",
  SF_2 = "SF2",
  SF_3 = "SF3",
  SF_4 = "SF4",
  SF_5 = "SF5",
  SF_6 = "SF6",
  SF_7 = "SF7",
  SF_8 = "SF8",
  SF_9 = "SF9",
  SF_10 = "SF10",
  SF_11 = "SF11",
  SF_12 = "SF12",
  SF_13 = "SF13",
  SF_14 = "SF14",
  SF_15 = "SF15",
  SF_16 = "SF16",
  SF_17 = "SF17",
  SF_18 = "SF18",
  SF_19 = "SF19",
  SF_20 = "SF20",
  SF_21 = "SF21",
  SF_22 = "SF22",
  SF_23 = "SF23",
  SF_24 = "SF24",
  SF_25 = "SF25",
  SF_26 = "SF26",
  SF_27 = "SF27",
  SF_28 = "SF28",
  SF_29 = "SF29",
  SF_30 = "SF30",
  SF_31 = "SF31",
  SF_32 = "SF32",
  SF_33 = "SF33",
  SF_34 = "SF34",
  SF_35 = "SF35",
  SF_36 = "SF36",
  SF_37 = "SF37",
  SF_38 = "SF38",
  SF_39 = "SF39",
  SF_40 = "SF40",
  SF_41 = "SF41",
  SF_42 = "SF42",
  SF_43 = "SF43",
  SF_44 = "SF44",
  SF_45 = "SF45",
  SF_46 = "SF46",
  SF_47 = "SF47",
  SF_48 = "SF48",
  SF_49 = "SF49",
  SF_50 = "SF50",
  LASTSCHRIFT = "Lastschrift",
  RECHNUNG = "Rechnung",
  //
  STANDARD = "Standard",
  SAISONKENNZEICHEN = "Saisonkennzeichen",
  DIPLOMATENKENNZEICHEN = "Diplomatenkennzeichen",
  WECHSELKENNZEICHEN = "Wechselkennzeichen",
  OLD_TIMER = "Oldtimer",
  //
  NORMAL = "Normal",
  AGRARIER = "Agrarier",
  BEAMTE_OEFFTL_DIENST = "Beamte/öffentl. Dienst",
  BEAMTE_AUF_LEBENSZEIT = "Beamte auf Lebenszeit",
  //
  VERSICHERUNGSNEHMER = "Versicherungsnehmer",
  PARTNER = "Partner",
  BELIEBIGE_FAHRER = "Beliebige Fahrer",
  FAMILIENFAHRER = "Familienfahrer",
  UNBEKANNT = "Unbekannt",
  //
  DECKUNG_100_MIO = "Deckungssumme 100 Mio. €",
  DECKUNG_GESETZ = "Gesetzliche Mindestdeckungssummen",
  // Sonderausstattung Erweitert
  FAHRWERKTUNING = "Fahrwerktuning",
  TRIEBWERKTUNING = "Triebwerktuning",
  AUSPUFFTUNING = "Auspufftuning",
  INNENRAUMTUNING = "Innenraumtuning",
  KAROSSERIETUNING = "Karosserietuning",
  SONDERLACKIERUNG = "Sonderlackierung",
  SONDERBESCHRIFTUNG = "Sonderbeschriftung",
  OBERFLAECHE = "Besondere Oberflächenbehandlung",
  VERKLEIDUNG = "Verkleidung",
  AUDIOSYSTEM = "Audiosystem",
  VIDEOSYSTEM = "Videosystem",
  TECH_KOMM = "Technisches Kommunikationssystem",
  TECH_LEIT = "Technisches Leitsystem",
  SONST_KFZ_MEHRWERT = "Sonstiger Fahrzeugmehrwert",
  SONST_SPEZIAL = "Sonstiger Spezialaufbau",
  //
  MEHR_GESCHAEFT = "Überwiegend geschäftlich",
  MEHR_PRIVAT = "Überwiegend privat",
  NUR_GESCHAEFT = "Ausschließlich geschäftlich",
  NUR_PRIVAT = "Ausschließlich privat",
  PRIVAT_GESCHAEAEFT = "Privat und geschäftlich"
}
